import { GqlModelBaseFragment } from 'src/services'

export type TableModel = GqlModelBaseFragment & {
  tagDisplayName: string
  link?: string
}

export const activeModelCreditsMessage =
  'You have reached the active model credit limit for your subscription and will not be able to activate additional models. Contact your customer success manager to discuss additional credits or deactivate some of your active models.'
export const trainingCreditsMessage =
  'You have reached the training credit limit for your subscription and will not be able to train additional models. Contact your customer success manager to discuss additional training credits.'
